import LearningSpaceClassFeedbacks from './LearningSpaceClassFeedbacks'

export default LearningSpaceClassFeedbacks
